import { makeStyles } from '@material-ui/core/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { BLOG_PATH } from '../constants';

interface WidgetProps {
    title: string;
    imageUrl: string;
    description: string;
    id: string;
    category: string;
    timestamp: number;
    href?: string;
}

const useStyles = makeStyles((theme) => ({
    card: {
        [theme.breakpoints.down('sm')]: {
            width: 350,
        },
        [theme.breakpoints.up('sm')]: {
            maxWidth: 300,
            width: '100%',
        },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 16,
        overflow: 'hidden',
        margin: 0,
        border: '1px solid #d9e7f8',
        backgroundColor: '#f8fbff',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        boxShadow: 'none',
        '@media (pointer: fine)': {
            '&:hover': {
                cursor: 'pointer',
                transform: 'translateY(-2px)',
                boxShadow: '0px 10px 24px rgba(16, 56, 114, 0.12)',
            },
        },
    },
}));

function timestampToHumanReadableDate(timestamp: number) {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export default function RecommendedArticleWidget(props: WidgetProps) {
    const classes = useStyles();
    const destination = props.href || `/${BLOG_PATH}/post?id=${props.id}`;
    return (
        <Link to={destination} style={{ textDecoration: 'none', display: 'flex' }}>
            <Card className={classes.card}>
                <CardMedia sx={{ height: 180 }} image={props.imageUrl} title={props.title} />
                <CardContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        pb: 1.5,
                        '&:last-child': {
                            pb: 1.5,
                        },
                    }}
                >
                    <Typography
                        sx={{
                            color: '#4d72a9',
                            fontWeight: 700,
                            fontSize: 11,
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            mb: 0.5,
                        }}
                    >
                        {props.category}
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div" sx={{ color: '#163f86', fontWeight: 700 }}>
                        {props.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#325887', mb: 0.9 }}>
                        {props.description}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#55729f' }}>
                        {timestampToHumanReadableDate(props.timestamp)}
                    </Typography>
                </CardContent>
            </Card>
        </Link>
    );
}
